<script lang="ts">
	import type { ObservedRestaurant } from "$lib/ui/home/food/menu/Restaurant.svelte";
	import type { RxWritable } from "$lib/util/obs";
	import type { ObservedValueOf } from "rxjs";
	import type { RestaurantDeal } from "$lib/serv/food-landing";
	import type { RestaurantDynamic, RestaurantSemiStatic } from "$lib/def/landing";
	import type { RestaurantExposed } from "$lib/serv/restaurant";
	import type { Restaurant } from "proto/restaurant";

	import { Vertical } from "$lib/def/verticals";
	import { getRestaurantState } from "$lib/serv/restaurant";

	import Search from "$lib/ui/form/Search.svelte";
	import Header from "$lib/ui/shared/Header.svelte";
	import LazyImage from "$lib/ui/shared/LazyImage.svelte";
	import StatusPills from "$lib/ui/shared/StatusPills.svelte";
	
	export let backHref: string;
	export let loading: boolean | undefined;
	export let restaurant: Partial<RestaurantExposed & RestaurantSemiStatic & RestaurantDynamic>;
	export let deals: RestaurantDeal[] | undefined;
	export let error: any;

</script>
{#if loading}
	<!-- TODO: Loading skeleton -->
{:else if error}
	<!-- TODO: Error with getting restaurant details - what must happen? -->
{:else if restaurant}
	{@const state = getRestaurantState(restaurant)}
	<Header back={backHref} image={restaurant.images?.restaurant_header}>

		<div slot="info">
			{#if state?.offline}
				<StatusPills pills={[{pos: 'BL', color: 'white', text: 'Offline', subText: state.text }]} darkended={true}/>
			{:else if state?.collect_only}
				<StatusPills pills={[{pos: 'BL', color: 'white', text: 'Collect', subText: `${restaurant?.prep_time} mins`, icon: 'icon-collect-16' }]} darkended={true}/>
			{:else if state?.text}
				<StatusPills pills={[{pos: 'BL', color: 'white', text: state.text }]}/>
			{/if}
		</div>

		<div class="flex-row align-center">
			<!-- {#if restaurant.images?.restaurant_logo}
				<div class="logo-container">
					<LazyImage image={[restaurant.images.restaurant_logo, 84]} alt={restaurant.name}/>
				</div>
			{/if} -->
			{#if restaurant.name}	
				<div>
					<h1 class="display-s bold">{restaurant.name}</h1>
				</div>
			{/if}
		</div>

		{#if restaurant.statistics?.avg_food_quality_rating}
			<span class="grey-pill body-m medium">
				{restaurant.statistics.avg_food_quality_rating.toFixed(1)}
				<span class="icon-star-20 vertical-middle"></span>
				{#if restaurant.statistics?.number_of_ratings_str}
					<span class="grey">{restaurant.statistics?.number_of_ratings_str}</span>
				{/if}
			</span>
		{/if}

		{#if restaurant.distance}
			<span class="grey-pill body-m medium">{(restaurant.distance / 1000).toFixed(2)} km</span>
		{/if}

		{#if restaurant.vertical !== Vertical.Store}
			<p class="m-top-0 body-m book">{restaurant.tags?.slice(0,10).map(t => t.name).join(', ')}</p>
		{/if}

		<article class="promo-messages">
			{#if deals?.length}
				{#each deals as deal}
					<div class="medium">
						<span class="flex {deal.origin === 'promo_delivery' ? 'icon-gift-filled-20' : 'icon-promo-filled-20'}"></span>
						{deal.label}
					</div>
				{/each}
			{/if}
		</article>

		<!-- <Search bind:value={$search$} placeholder={`Search ${restaurant.name}`}/> MOVED TO PARENT COMPONENT-->
	</Header>
{:else}
	<!-- TODO: What happens if cache has loaded and `restaurant` is still undefined? -->
{/if}

<style lang="scss">
	@use "color";
	@use "layout";

	.logo-container {
		margin-right: 1.1rem;
		background: color.$white;
		border-radius: 10px;
		max-width: 60px;
		min-width: 60px;
		height: 60px;
		max-height: 60px;
		min-height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 2px;
		img {
			border-radius: 10px;
			box-shadow: layout.$box-shadow;
		}
	}
	
	.grey-pill {
		display: inline-block;
		padding: 4px 12px;
		border-radius: 100px;
		background-color: color.$object-elevation-3dp;
		margin-right: 8px;
	}

	.promo-messages {
		width: 100%;
		display: flex;
    /*flex-direction: column;*/
		flex-wrap: wrap;
		gap: 8px;
    align-items: flex-start;
		div {
			background: color.$red-2;
			border-radius: 50px;
			padding: .3rem .8rem;
			color: color.$white;
			/*margin-bottom: 1rem;*/
			display: inline-flex;
			align-items: center;
			&:last-child {
				margin-bottom: 1.5rem;
			}
			span { 
				display: flex;
				margin-right: .3rem;
			}
		}
	}
</style>